module.exports = __webpack_public_path__ + "img/ireland.1b45bace.svg";